<template>
    <div class="create-asset__file-wrapper">
        <label class="create-asset__file-label" :for="elementName">
            <span
                class="button button--yellow text--uppercase"
                :class="`button--${elementSize}`"
                >{{
                    buttonLabel
                        ? buttonLabel
                        : 'ADD FILE' + (maxFiles > 1 ? 'S' : '')
                }}</span
            >
        </label>
        <input
            :id="elementName"
            ref="fileInput"
            type="file"
            :accept="getKnowTypes()"
            :name="elementName"
            class="create-asset__file-input"
            :multiple="maxFiles > 1"
            @change="addFile"
        />

        <div v-if="error" class="modal-main__file-wrap">
            <div class="file__error">{{ error }}</div>
        </div>
    </div>
</template>

<script>
import AssetsResource from '@/services/assets';
import { mapGetters } from 'vuex';
import StringUtil from '@/lib/stringUtil';
// import runtimeConfig from '@/components/assetCreate/runtimeConfiguration';

import { TYPES } from '@/components/assetCreate/const';

export default {
    props: {
        buttonLabel: {
            type: String,
            default: 'add file',
        },
        controller: {
            type: Object,
        },
        maxFiles: {
            // max amount of files
            type: Number,
            default: 1,
        },
        maxFileSize: {
            type: Number,
            default: 5, // im megabytes
        },
        fileType: {
            type: String,
            validator(val) {
                return val === TYPES.IMAGES;
            },
        },
        elementName: {
            type: String,
            required: true,
        },
        elementSize: {
            type: String,
            default: 'xl',
        },
    },
    data() {
        return {
            uploading: false,
            uploadingFiles: [],
            error: null,
            knownTypes: {
                [TYPES.IMAGES]: {
                    accept: 'image/*',
                    checkType: 'image',
                    error: 'Error, we accept only images',
                },
            },
        };
    },
    computed: {
        ...mapGetters('settings', {
            clientId: 'clientId',
        }),
        //TODO: make object with errors;
        maxFilesLengthError() {
            return `You can upload up to ${this.maxFiles} files`;
        },
        maxFilesSizeError() {
            return `File size should be less than ${this.maxFileSize}Mib`;
        },
    },
    methods: {
        getKnowTypes() {
            return this.knownTypes[this.fileType].accept;
        },
        removeFromUploads(identifier) {
            for (let i = 0; i < this.uploadingFiles.length; i++) {
                if (identifier !== this.uploadingFiles[i].identifier) {
                    continue;
                }
                this.uploadingFiles.splice(i, 1);
                return;
            }
        },
        addFile(e) {
            this.uploading = true;
            const el = Array.apply(null, e.target.files);

            this.uploadingFiles = [];
            for (let i = 0; i < el.length; i++) {
                if (i >= this.maxFiles) {
                    break;
                }
                let item = el[i];
                let identifier = StringUtil.makeid();
                try {
                    this.validate(item);
                    let formData = new FormData();
                    formData.append('file', item, item.name);
                    this.uploadingFiles.push({
                        cancel: () => {
                            this.removeFromUploads(identifier);
                        },
                        identifier: identifier,
                        file: item,
                        fileName: item.name,
                        progress: 0,
                        status: 'init',
                        formData: formData,
                        error: null,
                    });
                } catch (e) {
                    this.uploadingFiles.push({
                        identifier: identifier,
                        file: item,
                        fileName: item.name,
                        status: 'error',
                        errorMessage: e.message,
                    });
                }
            }

            this.$emit('upload-complete', this.uploadingFiles);
            this.uploadingFiles = [];

        },
        validate(file) {
            if (file.size > this.maxFileSize * 1000 * 1000) {
                throw new Error(
                    'File is too big. Maximum size of an image should not exceed ' +
                        this.maxFileSize +
                        ' Megabyte' +
                        (this.maxFileSize > 1 ? 's' : '')
                );
            }
            if (
                this.fileType === TYPES.IMAGES &&
                file.type !== 'image/jpeg' &&
                file.type !== 'image/png' &&
                file.type !== 'image/jpg'
            ) {
                throw new Error(
                    'Unsupported image format. Only JPG, PNG files are supported.'
                );
            }
        },
        setError(string) {
            this.error = string;
        },
        resetError() {
            this.error = null;
        },
        resetInput() {
            this.$refs.fileInput.value = '';
        },
    },
};
</script>
